(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/hooks/assets/javascripts/use-max-grid-items.js') >= 0) return;  svs.modules.push('/components/casino-react/hooks/assets/javascripts/use-max-grid-items.js');

'use strict';

const {
  useCasinoDisplaySize
} = svs.components.casino_react.hooks;
const useMaxGridItems = (items, ruleset) => {
  const casinoDisplaySize = useCasinoDisplaySize();
  if (!(ruleset !== null && ruleset !== void 0 && ruleset.maxItems)) {
    return items;
  }
  const maxItems = items.slice(0, ruleset.maxItems[casinoDisplaySize]);
  return maxItems;
};
setGlobal('svs.components.casino_react.hooks.useMaxGridItems', useMaxGridItems);

 })(window);